import { openDB, deleteDB } from 'idb';

const DB_NAME = 'cfms_data';
const STORE_NAME = 'polygons';

export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

export async function saveHexagons(data) {
  const db = await getDB();
  await db.put(STORE_NAME, data, 'polygons');
}

export async function loadHexagons() {
  const db = await getDB();
  return db.get(STORE_NAME, 'polygons');
}

export async function clearHexagons() {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).clear();
  await tx.done;
}

export async function deleteDatabase() {
  await deleteDB(DB_NAME);
}
